<!-- <ig-button *ngIf="!useDiv" [passClickEvent]="true" [icon]="icon">
    <ng-content></ng-content>
    <span>{{text}}</span>
</ig-button> -->

<div *ngIf="!useDiv" class="btn mat-raised-button mat-primary md has-icon div-text-trigger">
    <ng-content></ng-content>
    <span class="text">{{text}}</span>
</div>

<div *ngIf="useDiv" class="div-trigger" role="button">
    <mat-icon *ngIf="useIcon">{{icon}}</mat-icon>
    <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/drop.down/trigger/drop.down.trigger.component.html